import { supabase } from "../../../Services/supabaseClient";

/**
 * Fetch COA safely.
 * Try selecting + ordering by "code" first (if column exists),
 * then fallback to a query without "code".
 */
export async function fetchCompanyCOA(companyId) {
  if (!companyId) return [];

  // Try: if `code` exists
  const withCode = await supabase
    .from("chart_of_accounts")
    .select("id,name,type,category,code")
    .eq("company_id", companyId)
    .order("code", { ascending: true });

  if (!withCode.error) return withCode.data || [];

  // Fallback: if `code` does NOT exist (avoid 400)
  const withoutCode = await supabase
    .from("chart_of_accounts")
    .select("id,name,type,category")
    .eq("company_id", companyId);

  if (withoutCode.error) throw withoutCode.error;

  return (withoutCode.data || []).sort((a, b) =>
    String(a.name || "").localeCompare(String(b.name || ""))
  );
}
